import superMeta from '../_ALG/metaAlgNode.mjs'

export default {
    ...superMeta,
    algType: 'DATAFLOW',
    name: '子流程',
    ownerIdProp: 'bfId',
    ownerTextProp: 'bfName',
    ownerType: 'BF',
    type: 'BFDATAFLOW',
}
